/** tempexp_14728-full-file */
import React, { FC } from 'react';

import { AttachItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox/Checkbox';
import { Date } from '../Date/Date';
import { Destination } from '../Destination/Destination';
import { Download } from '../Download/Download';
import { ItemName } from '../ItemName/ItemName';
import { Pic } from '../Pic/Pic';
import { Size } from '../Size/Size';
import { TableColumn } from '../TableColumn/TableColumn';

interface AttachProps extends AttachItemProps {
    checkboxClassname?: string;
}

export const Attach: FC<AttachProps> = (props) => {
    return (
        <>
            <TableColumn>
                <Checkbox className={props.checkboxClassname} onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                <Pic isFolder={props.isFolder} thumbUrl={props.thumbUrl} isVirus={false} ext={props.ext || ''} author={props.owner} />
            </TableColumn>
            <TableColumn width="60%" overflow="hidden">
                <ItemName name={props.name} ext={props.ext || ''} />
            </TableColumn>
            <TableColumn width="40%" overflow="hidden">
                <Destination destination={props.subject} author={props.owner} openAttachLetter={props.openAttachLetter} isAttaches />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="flex-end">
                <Date date={props.mtime} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} onSaveToCloud={() => props.onClone('attaches-autodelete-tooltip')} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                <Download onClick={props.onDownload} ext={props.ext} size={props.size} id={props.id} storage={props.storage} />
            </TableColumn>
        </>
    );
};
